import { Markdown } from "@/component/Markdown";
import { memo } from "react";

interface IProps {
  text: string;
}

export const AssistantMessage = memo((props: IProps) => {
  const { text } = props;
  return (
    <div className="text-text-primary">
      <Markdown>{text}</Markdown>
    </div>
  );
});

AssistantMessage.displayName = "AssistantMessage";
